import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";
import { useParams } from "react-router-dom";

function RevenueBreakdown({ revenueBreakdown }) {
  const [tabData, setTabData] = useState([]);
  const { clientName, competitorName } = useParams();
  // Columns for GenericTable
  const tableColumns = [
    { key: "americas", label: "Americas" },
    { key: "emea", label: "EMEA" },
    { key: "apac", label: "APAC" },
    { key: "revenue_mix", label: "Revenue Mix" },
  ];

  // const dummyData = [
  //   {
  //     competitor: clientName ?? "HB Fuller",
  //     americas: "~$220B",
  //     emea: "Limited",
  //     apac: "Limited",
  //     revenue_mix: "85% Pharma, 10% Medical, 5% Specialty",
  //     americas_positive_insight: "~$220B",
  //     americas_negative_insight: "~$220B",
  //     americas_recent_development: "~$220B",
  //     emea_positive_insight: "Limited",
  //     emea_negative_insight: "Limited",
  //     emea_recent_development: "Limited",
  //     apac_positive_insight: "Limited",
  //     apac_negative_insight: "Limited",
  //     apac_recent_development: "Limited",
  //     revenue_mix_positive_insight: "85% Pharma, 10% Medical, 5% Specialty",
  //     revenue_mix_negative_insight: "85% Pharma, 10% Medical, 5% Specialty",
  //     revenue_mix_recent_development: "85% Pharma, 10% Medical, 5% Specialty",
  //   },
  //   {
  //     competitor: competitorName ?? "Tailored Chemical Products",
  //     americas: "~$20B",
  //     emea: "~$2B",
  //     apac: "~$1B",
  //     revenue_mix: "Medical-Surgical, Extended Care",
  //     americas_positive_insight: "~$220B",
  //     americas_negative_insight: "~$220B",
  //     americas_recent_development: "~$220B",
  //     emea_positive_insight: "Limited",
  //     emea_negative_insight: "Limited",
  //     emea_recent_development: "Limited",
  //     apac_positive_insight: "Limited",
  //     apac_negative_insight: "Limited",
  //     apac_recent_development: "Limited",
  //     revenue_mix_positive_insight: "85% Pharma, 10% Medical, 5% Specialty",
  //     revenue_mix_negative_insight: "85% Pharma, 10% Medical, 5% Specialty",
  //     revenue_mix_recent_development: "85% Pharma, 10% Medical, 5% Specialty",
  //   },
  //   {
  //     competitor: "AmerisourceBergen",
  //     americas: "~$345B",
  //     emea: "Minimal (post-EU divest)",
  //     apac: "Australia/NZ",
  //     revenue_mix: "Pharma, Tech, Oncology",
  //     americas_positive_insight: "~$220B",
  //     americas_negative_insight: "~$220B",
  //     americas_recent_development: "~$220B",
  //     emea_positive_insight: "Limited",
  //     emea_negative_insight: "Limited",
  //     emea_recent_development: "Limited",
  //     apac_positive_insight: "Limited",
  //     apac_negative_insight: "Limited",
  //     apac_recent_development: "Limited",
  //     revenue_mix_positive_insight: "85% Pharma, 10% Medical, 5% Specialty",
  //     revenue_mix_negative_insight: "85% Pharma, 10% Medical, 5% Specialty",
  //     revenue_mix_recent_development: "85% Pharma, 10% Medical, 5% Specialty",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(revenueBreakdown);
    setTabData(tableData);
  }, [revenueBreakdown]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    {
      type: "conversation",
      title: "Conversation",
      onClick: () => {},
    },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Revenue Breakdown"
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default RevenueBreakdown;
